import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom'
import BindMenu from '../modules/accountBind/BindMenu'
import AccountBind from '../modules/accountBind/AccountBind'
import NewAlbum from '../modules/album/NewAlbum'
import UploadImage from '../modules/album/UploadImage'
import UploadVideo from '../modules/video/UploadVideo'
import ClassAlbum from '../modules/album/ClassAlbum'
import PictureList from '../modules/album/PictureList'
import VideoPlayer from '../modules/video/VideoPlayer'
import PrincipalMailbox from '../modules/principalMailbox/PrincipalMailbox'
import MeetingSignIn from '../modules/meeting/MeetingSignIn'
import PhonesSelect from '../modules/phonesBook/PhonesSelect'
import PhonesList from '../modules/phonesBook/PhonesList'
import LeaveListPage from '../modules/leave/LeaveListPage'
import ReleaseAssignmentPage from '../modules/homework/ReleaseAssignmentPage'
import AssignmentListPage from '../modules/homework/AssignmentListPage'
import AssignmentDetailPage from '../modules/homework/AssignmentDetailPage'
import LeaveApprovalPage from '../modules/leave/LeaveApprovalPage'
import LeaveAddPage from '../modules/leave/LeaveAddPage'
import VoteListPage from '../modules/vote/VoteListPage'
import SystemMessage from '../modules/message/SystemMessage'
import UseHelp from '../modules/message/UseHelp'
import AccessNotice from '../modules/hiPages/access-notice/AccessNotice'
import FieldTrip from '../modules/hiPages/field-trip/FieldTrip'
import ResApply from '../modules/hiPages/res_apply/ResApply'
import SendVote from '../modules/hiPages/send-vote/SendVote'
import SendMeet from '../modules/hiPages/sendMeetting/SendMeet'
import ClassSchedule from '../modules/hiPages/class-schedule/ClassSchedule'
import ScoreInquiry from '../modules/hiPages/score-inquiry/ScoreInquiry'
import Approvel from '../modules/hiPages/approvel/Approvel'
import ApprovelDetail from '../modules/hiPages/approvel-detail/ApprovelDetail'
import MeetDetail from '../modules/hiPages/meet-detail/MeetDetail'
import LeaveDetail from '../modules/hiPages/LeaveDetail/LeaveDetail'
import WonderMoment from '../modules/video/WonderMoment'
import NotifyBoardParent from '../modules/notificationCenter/NotifyBoardParent'
import ConsumeRePage from '../modules/consumeManager/ConsumeRePage'
import CampusCardRecharge from '../modules/payment/CampusCardRecharge'
import RechargeList from '../modules/payment/RechargeList'
import RechargeRelease from '../modules/payment/RechargeRelease'
import AnnounceRelease from '../modules/announce/AnnounceRelease'
import PrincipalHistory from '../modules/principalMailbox/PrincipalHistory'
import VoteDetailPage from '../modules/vote/VoteDetailPage'
import UserInfo from '../modules/user/UserInfo'
import PicturesWallItem from '../components/upload/PicturesWallItem'
import NotifyBoardTeacher from '../modules/notificationCenter/NotifyBoardTeacher'
import ClassRechargeList from '../modules/payment/ClassRechargeList'
import ClassRechargeDetail from '../modules/payment/ClassRechargeDetail'
import LeaveAddCPage from '../modules/leave/LeaveAddCPage'
import VoteListTabPage from '../modules/vote/VoteListTabPage'
import TestImagesViewer from '../modules/demo/TestImagesViewer'
import ImageGrid from '../components/image/ImageGrid'
import MobileUpload from '../components/upload/MobileUpload'
import MobileUploadDemo from '../modules/demo/MobileUploadDemo'
import HomePage from '../modules/home/HomePage'
import VoteListParent from '../modules/vote/VoteListParent'
import VoteListTeacher from '../modules/vote/VoteListTeacher'
import HomeWorkList from '../modules/homework/HomeWorkList'
import NotifyBoardDetail from '../modules/notificationCenter/NotifyBoardDetail'
import PhonesSearch from '../modules/phonesBook/PhonesSearch'
import ChangePhoneNumber from '../modules/hiPages/changephonenumber/ChangePhoneNumber'
import PhoneInfo from '../modules/user/PhoneInfo'
import PhoneAddPage from '../modules/user/PhoneAddPage'
import ScoreNotification from '../modules/hiPages/scorenotification/ScoreNotification'
import ChartDemo from '../modules/chart/ChartDemo'
import { connect } from 'react-redux'
import AccessNoticeDetail from '../modules/hiPages/accessnoticedetail/AccessNoticeDetail'
import RechargeHome from '../modules/recharge/RechargeHome'
import RechargeDetail from '../modules/recharge/RechargeDetail'
import RechargePayList from '../modules/recharge/RechargePayList'
import RechargeIntroduce from '../modules/recharge/RechargeIntroduce'
import PayResult from '../modules/recharge/PayResult'
import RepairApply from '../modules/repairApply/RepairApply'
import Management from '../modules/repairApply/management/Management'
import ManagementList from '../modules/repairApply/management/ManagementList'
import ManagementDetail from '../modules/repairApply/management/ManagementDetail'
import BureauBoardDetail from '../modules/notificationCenter/BureauBoardDetail'
import FileManagement from '../modules/file/FileManagement'
import FileManagementDetail from '../modules/file/FileManagementDetail'
import Roster from '../modules/students/roster/Roster'
import RosterApply from '../modules/students/rosterApply/RosterApply'
import CardLose from '../modules/icCard/CardLose'
import CardSearch from '../modules/icCard/CardSearch'
import RechargeInfoService from '../modules/recharge/RechargeInfoService'
import RechargeInfoServiceRecord from '../modules/recharge/RechargeInfoServiceRecord'
import VisitApply from '../modules/visitorRegister/VisitApply'
import VisitList from '../modules/visitorRegister/VisitList'
import VisitDetail from '../modules/visitorRegister/VisitDetail'
import ServiceApply from '../modules/serviceCost/ServiceApply'
import ServiceExplain from '../modules/serviceCost/ServiceExplain'
import ServicePayCost from '../modules/serviceCost/ServicePayCost'
import ElectronicCard from '../modules/electronicCard/ElectronicCard'
import ElectronicCardOnOff from '../modules/electronicCard/ElectronicCardOnOff'
import ElectronicCardData from '../modules/electronicCard/ElectronicCardData'
import ElectronicCardDataDetail from '../modules/electronicCard/ElectronicCardDataDetail'
import AddressBook from '../modules/electronicCard/AddressBook'
import AddressBookAdd from '../modules/electronicCard/AddressBookAdd'
import ElectronicCardOn from '../modules/electronicCard/ElectronicCardOn'
import ElectronicCardOff from '../modules/electronicCard/ElectronicCardOff'
import AffectionPhone from '../modules/electronicCard/AffectionPhone'
import SosPhone from '../modules/electronicCard/SosPhone'
import NoDisturbing from '../modules/electronicCard/NoDisturbing'
import AddNoDisturbing from '../modules/electronicCard/AddNoDisturbing'
import DormitorySchool from '../modules/dormitory/DormitorySchool'
import VisitorDetail from '../modules/visit/visitordetail/VisitorDetail'
import SchoolFees from '../modules/schoolFees/SchoolFees'
import PayForSchool from '../modules/schoolFees/PayForSchool'
import AlbumApply from '../modules/graduation/album/AlbumApply'
import AlbumPay from '../modules/graduation/album/AlbumPay'
import AlbumPreview from '../modules/graduation/preview/AlbumPreview'
import PreviewApply from '../modules/graduation/preview/PreviewApply'
import ChechPreview from '../modules/checkIn/ChechPreview'
import ChechApply from '../modules/checkIn/ChechApply'
import PreviewPage from '../modules/graduation/preview/PreviewPage'
import GroupApply from '../modules/graduation/preview/GroupApply'
import PayableCost from '../modules/phone/PayableCost'
import PayableCostRecord from '../modules/phone/PayableCostRecord'
import CloudCourse from '../modules/computer/CloudCourse'
import Calligraphy from '../modules/write/Calligraphy'

class RouteConfig extends Component {

  render () {
    return (
      <Router>
        <div>
          <Switch>
            <Route exact path='/' render={() => (
              <Redirect to={'/bindMenu/app/' + this.props.userInfo.appId}/>
            )}/>

            {/*赵耀*/}
            <Route path='/repairApply' component={RepairApply}/>{/*教师端维修申请*/}
            <Route path='/management' component={Management}/>{/*物业管理列表*/}
            <Route path='/managementList/:type/:maId?'
                   component={ManagementList}/>{/*物业管理详情页*/}
            <Route path='/managementDetail/:type/:maId?'
                   component={ManagementDetail}/>{/*物业管理推送详情页*/}
            <Route path='/bureauDetail/:role/:bureauId'
                   component={BureauBoardDetail}/>{/*教育公告详情*/}
            <Route path='/fileListTab' component={FileManagement}/>{/*文件管理 */}
            <Route path='/fileMgtDetail/:role/:fileMgtId'
                   component={FileManagementDetail}/>{/*文件管理详情*/}
            <Route path='/roster' component={Roster}/>{/*学生名单*/}
            <Route path='/rosterApply/:gradeClazz/:clazzId/:schoolId'
                   component={RosterApply}/>{/*学生名单家长信息*/}
            <Route path='/cardLose' component={CardLose}/>{/*校园卡挂失*/}
            <Route path='/cardSearch/:type/:clazzId'
                   component={CardSearch}/>{/*校园卡持卡人搜索页面*/}

            <Route path='/dormitory'
                   component={DormitorySchool}/>{/*学生到校情况*/}
            <Route path="/visit/visitordetail/:anId"
                   component={VisitorDetail}/> {/*访客拜访通知详情*/}
            <Route path='/schoolFees'
                   component={SchoolFees}/>{/*学校费用提交*/}
            <Route path='/payForSchool'
                   component={PayForSchool}/>{/*学校费用提交*/}
            <Route path="/albumApply" component={AlbumApply}/>{/*毕业相册*/}
            <Route path='/albumPay/:id/:appId/:openId' component={AlbumPay}/>
            <Route path="/albumPreview" component={AlbumPreview}/>{/*毕业相册预览*/}
            <Route path="/previewApply/:schoolId/:clazzId/:appId/:openId/:ruleId" component={PreviewApply}/>{/*毕业相册订购*/}
            <Route path="/chechPreview" component={ChechPreview}/>{/*毕业相册预览*/}
            <Route path="/chechApply/:appId/:schoolId/:gradeName" component={ChechApply}/>{/*毕业相册订购*/}
            <Route path="/previewPage/:type?" component={PreviewPage}/>{/*订购详情*/}
            <Route path="/groupApply" component={GroupApply}/>{/*订购详情*/}

            {/*饶猛*/}
            <Route path="/homePage" component={HomePage}/>{/*首页*/}
            <Route path='/userInfoPage/:type?' component={UserInfo}/>{/*个人信息*/}

            <Route path='/bindMenu/:type/:openid?/:wxAvatar?'
                   component={BindMenu}/>{/*绑定菜单页面*/}
            <Route path='/accountBind/:type?'
                   component={AccountBind}/>{/*绑定页面*/}

            <Route path='/rechargeInfoService'
                   component={RechargeInfoService}/>{/*信息服务费缴费页面*/}
            <Route path='/rechargeInfoServiceRecord'
                   component={RechargeInfoServiceRecord}/>{/*信息服务费缴费记录页面*/}
            <Route path='/payableCost'
                   component={PayableCost}/>{/*话机话费预存页面*/}
            <Route path='/payableCostRecord'
                   component={PayableCostRecord}/>{/*话机话费预存付费记录页面*/}
            <Route path='/cloudCourse'
                   component={CloudCourse}/>{/*云课程*/}
            <Route path='/calligraphy'
                   component={Calligraphy}/>{/*书法*/}

            <Route path='/newAlbum/:classId/:name?'
                   component={NewAlbum}/>{/*新建相册*/}
            <Route path='/uploadImage/:albumId'
                   component={UploadImage}/>{/*照片上传*/}
            <Route path='/classAlbum/:type?' component={ClassAlbum}/>{/*班级相册*/}
            <Route path='/pictureList/:type/:albumId/:title?'
                   component={PictureList}/>{/*相册详情*/}
            <Route path='/uploadVideo/:classId/:name?'
                   component={UploadVideo}/>{/*视频上传*/}
            <Route path='/videoPlayer/:title?'
                   component={VideoPlayer}/>{/*视频播放*/}

            <Route path='/phonesSelect' component={PhonesSelect}/>{/*教师端通讯录*/}
            <Route path='/phonesList/:type/:classId?/:classTitle?'
                   component={PhonesList}/>{/*家长端通讯录*/}
            <Route path='/phonesSearch/:type'
                   component={PhonesSearch}/>{/*通讯录搜索页面*/}

            <Route path='/principalMailbox'
                   component={PrincipalMailbox}/>{/*校长信箱*/}
            <Route path='/meetingSignIn' component={MeetingSignIn}/>{/*会议列表*/}
            <Route path='/systemMessage' component={SystemMessage}/>{/*系统消息*/}
            <Route path='/useHelp' component={UseHelp}/>{/*使用帮助*/}
            <Route path='/wonderMoment/:type?'
                   component={WonderMoment}/>{/*精彩瞬间*/}
            <Route path='/principalHistory'
                   component={PrincipalHistory}/>{/*校长信箱历史投递*/}
            <Route path='/campusCardRecharge/:type'
                   component={CampusCardRecharge}/>{/*校园卡*/}
            <Route path='/consumeRePage/:type/:cardId'
                   component={ConsumeRePage}/>{/*校园卡 1:消费记录 2.充值记录*/}

            <Route path='/rechargeList/:userId?'
                   component={RechargeList}/>{/*家长端收费列表*/}
            <Route path='/rechargeRelease'
                   component={RechargeRelease}/>{/*发起收费*/}
            <Route path='/classRechargeList'
                   component={ClassRechargeList}/>{/*班级收费列表*/}
            <Route path='/classRechargeDetail/:payId'
                   component={ClassRechargeDetail}/>{/*收费详情*/}

            <Route path='/announceRelease'
                   component={AnnounceRelease}/>{/*新建通知公告*/}
            <Route path='/notifyBoard/parent'
                   component={NotifyBoardParent}/>{/*家长端通知公告列表*/}
            <Route path='/notifyBoard/teacher'
                   component={NotifyBoardTeacher}/>{/*教师端通知公告列表*/}
            <Route path='/notifyDetail/:role/:notifyId'
                   component={NotifyBoardDetail}/>{/*通知公告详情*/}

            <Route path='/releaseAssignment'
                   component={ReleaseAssignmentPage}/>{/*作业发布*/}
            <Route path='/assignmentList/:role'
                   component={HomeWorkList}/>{/*作业列表*/}
            <Route path='/assignmentDetail/:role/:id'
                   component={AssignmentDetailPage}/>{/*作业详情*/}

            <Route path='/voteList' component={VoteListParent}/>{/*家长端投票列表*/}
            <Route path='/voteListTab'
                   component={VoteListTeacher}/>{/*教师端投票列表*/}
            <Route path="/voteDetail/:role/:id"
                   component={VoteDetailPage}/>{/*投票详情*/}

            <Route path="/visitApply" component={VisitApply}/>{/*拜访申请*/}
            <Route path="/visitList" component={VisitList}/>{/*拜访记录*/}
            <Route path="/visitDetail/:id" component={VisitDetail}/>{/*拜访详情*/}
            <Route path="/serviceApply" component={ServiceApply}/>{/*信息服务费*/}
            <Route path='/serviceExplain/:id/:appId/:openId' component={ServiceExplain}/>{/*服务说明*/}
            <Route path='/servicePayCost/:id/:appId/:openId/:schoolId' component={ServicePayCost}/>{/*服务费用支付*/}
            <Route path='/electronicCard' component={ElectronicCard}/>{/*电子学生证功能首页*/}
            <Route path='/electronicCardOnOff/:IMEI' component={ElectronicCardOnOff}/>
            <Route path='/electronicCardData/:IMEI' component={ElectronicCardData}/>
            <Route path='/electronicCardDataDetail/:IMEI/:data' component={ElectronicCardDataDetail}/>
            <Route path='/addressBook/:IMEI' component={AddressBook}/>
            <Route path='/addressBookAdd/:IMEI' component={AddressBookAdd}/>
            <Route path='/electronicCardOn/:IMEI' component={ElectronicCardOn}/>
            <Route path='/electronicCardOff/:IMEI' component={ElectronicCardOff}/>
            <Route path='/affectionPhone/:IMEI' component={AffectionPhone}/>
            <Route path='/sosPhone/:IMEI' component={SosPhone}/>
            <Route path='/noDisturbing/:IMEI' component={NoDisturbing}/>
            <Route path='/addNoDisturbing/:IMEI' component={AddNoDisturbing}/>

            {/*测试demo*/}
            <Route path='/chartDemo' component={ChartDemo}/>{/*图表测试页面*/}

            {/*方龙海*/}
            <Route path='/access-notice/:stuId?'
                   component={AccessNotice}/> {/*出入校通知*/}
            <Route path='/field-trip' component={FieldTrip}/> {/*//外勤出差*/}
            <Route path='/res_apply' component={ResApply}/>{/*//用品申请*/}
            <Route path='/send-vote' component={SendVote}/>{/*//发起投票*/}
            <Route path='/sendMeetting' component={SendMeet}/> {/*//发起会议*/}
            <Route path='/class-schedule'
                   component={ClassSchedule}/> {/*//课程表*/}
            <Route path='/score-inquiry' component={ScoreInquiry}/> {/*//成绩查询*/}
            <Route path='/approvel' component={Approvel}/>{/*我的审批*/}
            <Route path='/approvel-detail/:isMyApply/:approveId'
                   component={ApprovelDetail}/> {/*审批详情*/}
            <Route path='/meet-detail/:meetId?'
                   component={MeetDetail}/> {/*会议签到详情 meetingSignIn*/}
            <Route path='/leavedetail/:role/:lvId'
                   component={LeaveDetail}/> {/*学生请假详情*/}
            <Route path="/changephonenumber"
                   component={ChangePhoneNumber}/> {/*更换手机号码*/}
            <Route path="/phoneInfo"
                   component={PhoneInfo}/> {/*查看手机号*/}
            <Route path='/phoneAdd' component={PhoneAddPage}/>{/*添加号码*/}
            <Route path="/scorenotification/:stuId?"
                   component={ScoreNotification}/> {/*成绩通知*/}
            <Route path="/accessnoticedetail/:anId"
                   component={AccessNoticeDetail}/> {/*出入校通知详情*/}
            <Route path='/leaveAddC' component={LeaveAddCPage}/>{/*老师请假*/}
            <Route path='/leaveAdd' component={LeaveAddPage}/> {/*学生请假*/}
            <Route path='/leaveList/:role'
                   component={LeaveListPage}/>{/*学生请假列表*/}

            {/*刘杰*/}
            <Route path={'/MobileUploadDemo'} component={MobileUploadDemo}/>
            <Route path={'/MobileUpload'} component={MobileUpload}/>
            <Route path={'/ImageGrid'} component={ImageGrid}/>
            <Route path={'/TestImagesViewer'} component={TestImagesViewer}/>
            <Route path={'/picturesWall'} component={PicturesWallItem}/>
            <Route path='/leaveApproval' component={LeaveApprovalPage}/>

            {/*微信支付*/}
            <Route path='/rechargeHome' component={RechargeHome}/>
            <Route path='/rechargeDetail/:payId' component={RechargeDetail}/>
            <Route path='/rechargePayList' component={RechargePayList}/>
            <Route path='/rechargeIntroduce' component={RechargeIntroduce}/>
            <Route path='/payResult/:money' component={PayResult}/>
            {/*404页面*/}
            <Route render={() => (
              <Redirect to={'/bindMenu/app/' + this.props.userInfo.appId}/>
            )}/>
          </Switch>
        </div>
      </Router>
    )
  }
}

let mapStateToProps = (state) => ({
  userInfo: { ...state.redUserInfo },
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(RouteConfig)
